<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementBrandedProductSlider']
}>()

const items = computed(() => Object.values(props.content?.data?.elements ?? {}))

const slidesPerViewDesktop = computed(() => props.content?.config?.slideQty?.value ?? 3)
</script>

<template>
    <SliderBase
        :slides-per-view="{
            xs: 1,
            sm: 2,
            md: 2,
            lg: slidesPerViewDesktop,
        }"
        :slide-count="items.length"
        :mobile-grid="false"
        :display-nav="true"
        :space-between="8"
        progress-config="progress_bar"
    >
        <template #default="{ index }">
            <div class="product-swiper-slide w-full">
                <SliderSlideContentBrandedProducts
                    v-if="items[index] != null"
                    :config="items[index]!"
                    :index="index"
                />
            </div>
        </template>
    </SliderBase>
</template>